import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';

import { UiButton } from '@shared/ui';

import { ModalBody } from '../../../../../TemporaryConmonents/Gant/components/UI/Modal/ModalBody/ModalBody';
import { ModalFooter } from '../../../../../TemporaryConmonents/Gant/components/UI/Modal/ModalFooter/ModalFooter';
import { ModalHeader } from '../../../../../TemporaryConmonents/Gant/components/UI/Modal/ModalHeader/ModalHeader';
import cls from '../../PrevMedia.module.css';

interface EditTitleImageProps {
    onHideModal: () => void;
    isShow: boolean;
    name?: string;
    renameImage?: (fileName: string) => void;
}

export const EditTitleImage: FunctionComponent<EditTitleImageProps> = ({
    onHideModal,
    isShow,
    renameImage,
    name,
}) => {
    const [inputValue, setInputValue] = useState(name);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            event.stopPropagation();
            if (event.key === 'Escape') {
                onHideModal();
                event.stopPropagation();
            }
            if (event.key === 'Enter') {
                renameImage(inputValue);
                event.stopPropagation();
            }
        };
        if (isShow) {
            document.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isShow, onHideModal, inputValue]);

    useEffect(() => {
        if (isShow) {
            const submitButton = document.querySelector('.submitButton');
            if (submitButton) submitButton.focus();
        }
    }, [isShow]);

    const handleInput = useCallback((event) => {
        setInputValue(event.target.value);
    }, []);
    return (
        <>
            <ModalHeader>Переименовать файл</ModalHeader>
            <ModalBody width="476px" classes={cls.textAlignCenter}>
                <form>
                    <input onInput={handleInput} value={inputValue} className={cls.input} />
                </form>
            </ModalBody>
            <ModalFooter>
                <UiButton onClick={onHideModal} btnColor="secondary" btnText="Отмена" />
                <UiButton onClick={() => onRenameFile(inputValue)} btnText="Сохранить" />
            </ModalFooter>
        </>
    );
};
